import React from 'react';
import PropTypes from 'prop-types';

import {
    Collapsible, Heading, IconChevronRight, IconChevronUp, Spacer,
} from '@zillow/constellation';
import { Col, Container } from '@zillow/zrs-comet';

import { StyledRow } from './StyledComponents';

const propTypes = {
    header: PropTypes.string,
    content: PropTypes.node,
};
const defaultProps = {
    header: '',
    content: '',
};

const Accordion = ({ header, content, ...rest }) => (
    <Collapsible
        defaultCollapsed={true}
        // eslint-disable-next-line react/no-children-prop
        children={(collapsed, toggle) => (
            <Container {...rest}>
                <StyledRow isHeader={true} isCollapsed={collapsed} onClick={toggle}>
                    <Col xs={11}>
                        <Heading level="5">{header}</Heading>
                    </Col>
                    <Col xs={1} alignVertical="center">
                        {collapsed ? <IconChevronRight fontColor="gray400" /> : <IconChevronUp />}
                    </Col>
                </StyledRow>
                {collapsed ? (
                    null
                ) : (
                    <StyledRow isCollapsed={collapsed}>
                        <Spacer paddingY="lg" paddingX="xl">
                            {content}
                        </Spacer>
                    </StyledRow>
                )}
            </Container>
        )}
    />
);

Accordion.propTypes = propTypes;
Accordion.defaultProps = defaultProps;

export default Accordion;
